// extracted by mini-css-extract-plugin
export default {"base":"base--vUscH","base-40":"base-40--vUscH","base-60":"base-60--vUscH","title":"title--vUscH","contact":"contact--vUscH"};